<template>
  <div class="page">
    <SiteHero
      pageTitle="Affiliates"
      pageDescription="Our Network of Training Partners"
    />
  
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div v-for="(affiliate, index) in affiliatesData" :key="affiliate.name">
            <AffiliateCard :affiliate="affiliate" :isLast="index === affiliatesData.length - 1" />
          </div>
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>
  
<script>
  import SiteFooter from '../components/Footer/SiteFooter.vue';
  import SiteHero from '../components/Hero/SiteHero.vue';
  import AffiliateCard from '../components/Affiliate/AffiliateCard.vue';
  import affiliatesData from '../data/affiliates.json';
  import '../assets/styles/page.css';

  export default {
    name: 'AffiliatesPage',
    components: {
      SiteFooter,
      SiteHero,
      AffiliateCard,
    },
    data() {
      return {
        affiliatesData: affiliatesData.affiliates
      }
    }
  };
</script>
  